const listPointsBody = document.querySelector('#programmsFest-body');
const typeDisplay = document.querySelector('#programmsFest').querySelector('button[name=typeDataDisplay]')
const curTimeZone = document.querySelector('#programmsFest').querySelector('select[name=listTimeZone]');

const cardBody = document.querySelector('#program_card').querySelector('div[name=body]');

import auth from '../tools/storage.js';

import filmsWithoutMarkup from '../markup2/filmsWithoutProgramms.js';
import tools from '../tools/tools.js';
import buildBlocksJS from '../tools/buildBlocks.js';


export default {

  cleanContainer() {
    listPointsBody.innerHTML = '';
  },
/*
  getElement(item, index, headerid) {

    let blockFilms = '';
    let urlImg = 'http://festappbuilder.ru/content/festival/zeroplus/films/';

    let i;
    if(item.films)
      for (i = 0; i < item.films.length; i++) {
        blockFilms += ' <button id="programmsFilm_film_in_programm" type="button" class="btn btn-success p-0 icon-btn btn_film_in_program" data-toggle="modal"> ';
        blockFilms += '<img class = "img_film_in_program" style = "width:75px; height:57px" src="';
        blockFilms += urlImg;
        blockFilms += item.films[i].image;
        blockFilms += '_preview.jpg" title="';
        // blockFilms += '.jpg" title="';
        blockFilms += item.films[i].name + '" alt="';
        blockFilms += item.films[i].name + '" filmID="';
        blockFilms += item.films[i].id;
        blockFilms += '" programid="';
        blockFilms += item.id;
        blockFilms += '" originalJPG="';
        blockFilms += item.films[i].image;
        blockFilms += '"></button>';

      }
      let someColor = '';
      if(item.color)
        someColor = item.color;

    return `
      <div class="reference-header  block_item mb-3" >
        <div class = "row block_item_header">
          <div class = "block-item-color-preview w-10" style="background-color:#${someColor}"> </div>
          <span class="w-80 txt-al-left">${item.name}</span> 
          <div class="btn btn_edit" 
              blockid =${item.id} 
              blockname="${item.name}"
              blockparent=${headerid} 
              blockcolor="${someColor}" 
              blockorder = ${item.order} 
              blocktype = ${item.type}
              blockcanvote = ${item.canVote}>  </div>
        </div>
        <div class = "row">
            <div class="-box">
     
                ${blockFilms}
                <button id="programmsFilm-add_film_to_programm" programid="${item.id}" type="button" class="btn btn-success p-0 icon-btn btn_add_film_to_program" data-toggle="modal" data-target="#clients-add"> + </button>
    
            </div>
        </div>
        
      </div>`;

  },
*/
  drawChildDataInContainer(fullArrayData, allFilms, parentID, allProgramsHideNseekMemory, backButton){
    let answer = '';

    if(fullArrayData)
      fullArrayData.forEach((item, index) => {
        if(item.parent === parentID)
          answer =  `<div class="w-100 p-3"> ${this.drawDataInContainerOneBlock(item, fullArrayData,  allFilms, allProgramsHideNseekMemory, backButton)}</div>`;
      });

    return answer;

  },
  drawDataInContainerOneBlock(item, fullArrayData, allFilms, allProgramsHideNseekMemory, backButton){
    let fullHtml = '';
    let urlImg = '';
    let allTime = 0;
    
    // FILMS 

    let blockFilms = '';
    if (item.films) {
      if(typeDisplay.value < 0) 
        blockFilms = ` <div class="column w-100 p-1 m-3"><div class="reference-header firstRow w-100">
            <div class="reference-column">№</div>
            <div class="reference-column">Название работы</div>
        </div>`;
        else
          blockFilms = `<div class="row m-0 p-0">`;
      for (let i = 0; i < item.films.length; i++) {
        /* ОТОБРАЖЕНИЕ ИКОНКОЙ !!!
         */
        allFilms.forEach((fElement) => {
          // console.log(fElement);
          if(item.films[i].filmIDfk === fElement.id){
            if(typeDisplay.value < 0) 
              blockFilms += filmsWithoutMarkup.getElement(fElement, i, (i !== 0), (i+1 !== item.films.length), item.id);
            else {
              let fcID = ` fcid=${fElement.id} numReq=${item.numRequest} `;

              blockFilms += ` <button  ${fcID} id="programmsFilm_film_in_programm" type="button" class="btn  p-0 icon-btn btn_film_in_program" m-0 data-toggle="modal" style = "width:75px; height:57px" > `;
              blockFilms += `<img  ${fcID} class = "img_film_in_program" style = "width:75px; height:57px" src="`;
              blockFilms += `${window.appSettings.xhrSettings.urlContentFest}${auth.currentFestival}/films/${tools.jsonStringToStringgetElementBy(fElement.frames, 0)}_preview_150.jpg`
              blockFilms += '" title="';
              // blockFilms += '.jpg" title="';
              blockFilms += fElement.name + '" alt="';
              blockFilms += fElement.name + '" filmID="';
              blockFilms += fElement.id;
              blockFilms += '" programid="';
              blockFilms += fElement.id;
              blockFilms += '" originalJPG="';
              blockFilms += fElement.frames;
              blockFilms += '"></button>';
            }
            allTime += parseInt(fElement.long, 10);
          }
        });
      
      }
      blockFilms += '</div>';
    } else if(item.filmsWithNames){
      blockFilms = ` <div class="column w-100 p-1 m-3"><div class="reference-header firstRow w-100">
          <div class="reference-column">№</div>
          <div class="reference-column">Название работы</div>
      </div>`;
      item.filmsWithNames.forEach((fElement, index) => {
        blockFilms += filmsWithoutMarkup.getElement(fElement, index, (index !== 0), (index+1 !== item.filmsWithNames.length), fElement.id);
      });

      blockFilms += '</div>';

    }
/// обработка расписания

    let blockSchedule = '';
    if (item.schedule) 
      blockSchedule = buildBlocksJS.blockSchedule(item.schedule, curTimeZone.value);
    


// TIME

    let value = allTime;
    // let lhours = parseInt(value/(60*60), 10);
    // let lmins = parseInt(value/(60), 10);
    let lsec = value%(60);
    value -= lsec;
    value = value/60;
    let lmins = value%(60);;
    value -= lmins;
    value = value/60;
    let lhours =value;

    if(lhours < 10)
      lhours = `0${lhours}`;

    if(lmins < 10)
      lmins = `0${lmins}`;

    if(lsec < 10)
      lsec = `0${lsec}`;

    value = `${lhours}:${lmins}:${lsec}`;

    let canVoteStatus = 'Голосование запрещено';
    if(item.canVote)
      if(parseInt(item.canVote, 10) === 1)
        canVoteStatus = 'Голосование разрешено';

    let someColor = '';
    if(item.color)
      someColor = `<div class="colorPreview"  style="background-color:#${item.color};" ></div>`;

    let hideProgram = false;

    allProgramsHideNseekMemory.forEach((aElement) => {
      if(parseInt(item.id, 10) === parseInt(aElement, 10))
        hideProgram = true;
    });

    let backBtn = '';
    let swither = '';

    if(backButton)
      backBtn = '<button class="btn localTab" operation="closeOneProgram">Назад</button>';
    else if(!item.filmsWithNames)
      swither = `<div class="row ml-0 mr-0">
                          <i class="p-2">Свернуть детали:</i>
                          <div class="mt-0">
                            <label class="switch ml-auto  m-0  switch-pink-border">
                              <input type="checkbox" programid=${item.id} name="hideNshow" ${hideProgram ? 'checked' : ''}>
                              <span class="slider round"></span>
                            </label>
                          </div>  
                        </div>`;

                        // console.log(item);
    fullHtml += ` <div class = "block_items blockProgram">
                      <div class="row  m-0 p-3"> 
                        ${backBtn}
                        <b class="ml-auto mr-auto txt-al-center">${item.name} </b>
                        ${swither}
                      </div>
                     <div class="row  m-0 p-1 pl-3 pr-3 ${hideProgram ? 'd-none' : ''}"> 
                        ${someColor}
                        <div class="ml-3 cloud">
                          <img src="https://festcontent.ru/img/long.svg">
                          <b>${value}</b>
                          <small>${item.films ?('('+ item.films.length + ')'): ''}</small>
                        </div>
                        <div class="column ml-1 mr-1"> 
                          <i>${tools.getNameTypeProgramsFull(item.type)}</i>
                          <i>${canVoteStatus}</i>
                        </div> `;
    if(!item.filmsWithNames)
      fullHtml += ` 

                        <div class="btn btn_edit mr-1 ml-1" blockid =${item.id} 
                                                  blockname="${item.name}"  
                                                  blockcolor="${item.color}" 
                                                  blockorder = ${item.order} 
                                                  blockparent= ${item.parent}
                                                  blocktype = ${item.type}
                                                  blockcanvote = ${item.canVote}
                                                  name="editProgram" >  </div>
                                                  `;
    fullHtml += ` 
                        <div class="btn p-1  ml-auto mr-0 btn_add_film_to_program " name="addFilmInProgramm" programid="${item.id}">Добавить / убрать работу</div>
                        
                      </div>
                      <div name="filmsList" class=" row w-100 m-0 p-0  ${hideProgram ? 'd-none' : ''} ">${blockFilms}${this.drawChildDataInContainer(fullArrayData,allFilms,item.id, allProgramsHideNseekMemory, backButton)}</div>
                      <div name="scheduleRow" class=" row w-100 m-0 p-0">${blockSchedule}</div>`;


    fullHtml += `</div>`;
    return fullHtml;
  }
  ,
  drawDataInContainer(enterprisesData, fullArrayData, allFilms, allProgramsHideNseekMemory , backButton) {
    this.cleanContainer();
    let oldSection;

    let fullHtml = '';
 
    if(enterprisesData){
      enterprisesData.forEach((item, index) => {

        fullHtml += this.drawDataInContainerOneBlock(item, fullArrayData,  allFilms, allProgramsHideNseekMemory, backButton);
        // listArbitorsBody.insertAdjacentHTML('beforeend', this.getElement(item, index))
      });
      listPointsBody.innerHTML = fullHtml;
    } else 
      listPointsBody.innerHTML = 'Данных нет!';

  },


  drawDataInOneCard(oneProgramn) {
  

    let fullHtml = '';
 
    if(oneProgramn){
        fullHtml += this.drawDataInContainerOneBlock(oneProgramn, [],  [], [], false);
        // listArbitorsBody.insertAdjacentHTML('beforeend', this.getElement(item, index))

      cardBody.innerHTML = fullHtml;
    } else 
      cardBody.innerHTML = 'Данных нет!';

  },

  drawMarkupInContainer(markup) {
    listPointsBody.insertAdjacentHTML('beforeend', markup);
  },

};
